import spiderman from '@/spiderman/index';

const { axios, api } = spiderman;

async function send(member, feedbackForm) {
  return (
    await axios.post(api.feedbacks, {
      clinic: member.info.clinic,
      ...feedbackForm,
    },
    {
      headers: {
        jwt: member.jwt,
      },
    })
  ).data;
}

export default {
  send,
};
